import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Body } from '@swyftx/aviary/atoms/Typography';
import { Funnel } from '@swyftx/aviary/icons/outlined';

import { cn } from '@shared/utils/lib/ui';

import { useMarginPositionsTableFilterStore } from '../useMarginPositionsTableFilterStore';

const MarginPositionsShowFilter: React.FC = () => {
  const {
    filterCurrentInstrument,
    filterDirections,
    filterEvents,
    filterEndDate,
    filterStartDate,
    showFilters,
    setShowFilters,
  } = useMarginPositionsTableFilterStore();
  const { t } = useTranslation('margin');

  const totalFilters = useMemo(() => {
    let total = 0;
    if (filterCurrentInstrument?.length) total += 1;
    if (filterDirections.length > 0) total += 1;
    if (filterStartDate && filterEndDate) total += 1;
    if (filterEvents.length > 0) total += 1;

    return total;
  }, [filterCurrentInstrument?.length, filterDirections.length, filterEndDate, filterEvents.length, filterStartDate]);

  return (
    <FlexLayout
      alignItems='center'
      spacing={8}
      className={cn(
        'hidden cursor-pointer rounded-24 px-16 py-8 md:flex',
        showFilters ? 'bg-color-background-surface-selected' : 'border border-color-border-main',
      )}
      onClick={() => setShowFilters(!showFilters)}
    >
      <Funnel className={cn('h-16 w-16', showFilters ? 'text-color-text-selected' : '')} />
      <Body size='small' color={showFilters ? 'selected' : 'primary'} weight='emphasis' className='whitespace-nowrap'>
        {t('tables.positions.filters.filters', { totalFilters: totalFilters > 0 ? `(${totalFilters})` : '' })}
      </Body>
    </FlexLayout>
  );
};

export { MarginPositionsShowFilter };
